import React, { useEffect } from 'react'
import isMobile from 'ismobilejs'

import { scroll } from '../../lib/utils'
import Footer from '../../sections/footer'
import Providers from '../../sections/providers'
import WaveContainer from '../../components/wave-container'

import Faq from './components/faq'
import Hero from './components/hero'
import Intro from './components/intro'
import WhyFree from './components/why-free'
import Features from './components/features'
import SubFeatures from './components/subfeatures'
import SignupForm from './components/signup-form'
import Seo from '../../components/seo'

const Free: React.FC = () => {
  const signupRef = React.createRef<HTMLDivElement>()

  useEffect(() => {
    if (window.location.search.includes('bankidsessionid')) {
      setTimeout(() => {
        scroll(signupRef)
      }, 1000)
    }
  }, [signupRef])

  const clientIsMobileOrTablet = isMobile().phone || isMobile().tablet

  return (
    <>
      <Seo
        description="Yes, it's bokföring på ett nytt sätt. Det är inte bara en bokföringsapp, det är även fakturering och löner. And it's gratis."
        image="https://www.dooer.com/images/og/og_yellow.jpg"
        title="Gratis bokföring | Dooer"
        url="https://www.dooer.com"
      />

      <Hero cta={() => scroll(signupRef, 'start')} />

      <WaveContainer>
        <Intro />
      </WaveContainer>

      <WaveContainer>
        <Providers variant="light" />
      </WaveContainer>

      <WaveContainer>
        <Features />
        <SubFeatures handleClickRegister={() => scroll(signupRef)} />
      </WaveContainer>

      <div id="signup" ref={signupRef}>
        <SignupForm
          apps={['diyAccounting']}
          onAfterSubmit={() => {
            if (clientIsMobileOrTablet) {
              scroll(signupRef, 'start')
            }
          }}
          testimonals
        />
      </div>

      <WhyFree />

      <Faq />

      <Footer inverted />
    </>
  )
}

export default Free
